import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import FacebookLogin from 'react-facebook-login';

// import AvatarEditor from 'react-avatar-editor';

import { Theme } from '../../config/theme';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import { updateUser } from '../../actions/user';

import HorizontalRule from '../../components/HorizontalRule';
import TextField from '../../components/TextField';
import CheckboxField from '../../components/CheckboxField';
import Select from '../../components/Select';

class JoinDetails extends Component {
  constructor(props) {
    super(props);
    this.continue = this.continue.bind(this);
    this.state = {
      selected: 'owner',
      active: false,
      completed: false,

      first_name: props.user.first_name,
      last_name: props.user.last_name,
      email: props.user.email,
      phone: props.user.phone,
      suburb: props.user.suburb,
      password: props.user.password,
      confirmed_password: props.user.confirmed_password,
      newsletter: props.user.newsletter,
      dogs_in_area: props.user.dogs_in_area,
      accepted_terms: props.user.accepted_terms,
      facebook_token: props.user.facebook_token,
      fb_id: props.user.fb_id,

      errors: {
        first_name: false,
        last_name: false,
        email: false,
        phone: false,
        suburb: false,
        password: false,
        confirmed_password: false,
        newsletter: false,
        dogs_in_area: false,
        accepted_terms: false,
      },
    };

    this.setValue = this.updateTextField.bind(this);
    this.facebookCallback = this.facebookResponse.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        active: true,
      });
    }, 10);
  }

  // Handle "email already exists" error
  getEmailError() {
    if (this.state.errors.email) {
      return this.state.errors.email;
    } else if (this.props.location && this.props.location.state
      && this.props.location.state.error) {
      // If the user hasn't changed the value, then this error should persist.
      if (this.state.email === this.props.location.state.value) {
        return this.props.location.state.message;
      }
    }

    return false;
  }

  // Validate the form
  validateForm() {
    const errors = {};

    if (!this.state.first_name || !this.state.first_name.length > 0) {
      errors.first_name = 'Please enter your first name';
    } else {
      errors.first_name = null;
    }

    if (!this.state.last_name || !this.state.last_name.length > 0) {
      errors.last_name = 'Please enter your last name';
    } else {
      errors.last_name = null;
    }

    if (!this.state.email || !this.state.email.length > 0) {
      errors.email = 'Please enter your email address';
    } else {
      errors.email = null;
    }

    if (!this.state.phone || !this.state.phone.length > 0) {
      errors.phone = 'Please enter your phone number';
    } else {
      errors.phone = null;
    }

    if (!this.state.facebook_token) {
      if (!this.state.password) {
        errors.password = 'Please enter a password';
      } else {
        errors.password = null;
      }

      if (this.state.password) {
        if (this.state.password.length < 8) {
          errors.password = 'Password must be at least 8 characters.';
        } else {
          errors.password = null;
        }

        const hasNumber = /\d/;
        if (!hasNumber.test(this.state.password)) {
          errors.password = 'Password must contain at least one number.';
        } else if (!errors.password) {
          errors.password = null;
        }
      }

      if (!this.state.confirmed_password) {
        errors.confirmed_password = 'Please repeat your password';
      } else if (this.state.confirmed_password !== this.state.password) {
        errors.confirmed_password = 'Your passwords do not match';
      } else {
        errors.confirmed_password = null;
      }
    }

    if (!this.state.suburb) {
      errors.suburb = 'Please select a suburb';
    } else {
      errors.suburb = null;
    }

    if (!this.state.accepted_terms) {
      errors.accepted_terms = 'You must read and accept the Terms of Service.';
    } else {
      errors.accepted_terms = null;
    }

    let formErrors = false;

    for (const key in errors) {   //eslint-disable-line
      if (errors[key] !== null) {
        formErrors = true;
      }
    }

    if (formErrors) {
      this.setState({
        errors,
      });

      return false;
    }

    return true;
  }

  continue(history) {
    if (this.validateForm()) {
      const signupFields = {
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        phone: this.state.phone,
        suburb: this.state.suburb ? this.state.suburb.value : null,
        newsletter: this.state.newsletter,
        dogs_in_area: this.state.dogs_in_area,
        accepted_terms: this.state.accepted_terms,
        password: this.state.password,
        confirmed_password: this.state.confirmed_password,
      };

      if (this.state.facebook_token) {
        signupFields.facebook_token = this.state.facebook_token;
        signupFields.fb_id = this.state.fb_id;
      }

      this.props.dispatch(updateUser(signupFields));

      this.setState({
        completed: true,
      }, () => {
        setTimeout(() => {
          history.push('/join/payment');
        }, 500);
      });
    }
  }

  facebookResponse(response) {
    if (response && response.accessToken) {
      this.setState({
        first_name: response.first_name,
        last_name: response.last_name,
        email: response.email,
        facebook_token: response.accessToken,
        fb_id: response.id,
      });
    }
  }

  updateTextField(key, value) {
    const updatedState = {
      [key]: value,
    };

    this.setState(updatedState);

    setTimeout(() => {
      if (this.state.errors[key]) {
        // If there is an error against this field, attempt to revalidate
        this.validateForm();
      }
    }, 10);
  }

  render() {
    const Continue = withRouter(({ history }) => (
      <button
        className={css(styles.continue)}
        onClick={() => { this.continue(history); }}
      >Continue</button>
    ));

    return (
      <div className={css(
        styles.container,
        this.state.active ? styles.container_active : styles.container_inactive,
        this.state.completed ? styles.container_completed : null,
      )}>
        <div className={css(styles.main)}>
          <h1 className={css(styles.heading)}>Your membership details</h1>
          {
            !this.state.facebook_token ? (
              <FacebookLogin
                appId="727162037485391"
                autoLoad={false}
                fields="first_name,last_name,email,picture"
                callback={this.facebookCallback}
                cssClass="facebook-login-button"
                textButton={false}
                isMobile={false}
                icon={(
                  <div className={css(styles.facebook)}>
                    <button className={css(styles.facebook_btn)}>Sign up with Facebook</button>
                  </div>
                )}
            />
            ) : false
          }
          {
            !this.state.facebook_token ? (
              <div className={css(styles.or_label)}>Or</div>
            ) : false
          }
          <HorizontalRule />
          <div className={css(styles.form)}>
            <TextField
              id="first_name"
              name="first_name"
              label="First Name"
              value={this.state.first_name}
              handler={this.setValue}
              error={this.state.errors.first_name}
            />
            <TextField
              id="last_name"
              name="last_name"
              label="Last Name"
              value={this.state.last_name}
              handler={this.setValue}
              error={this.state.errors.last_name}
            />
            <TextField
              id="email"
              name="email"
              label="Email"
              email
              value={this.state.email}
              handler={this.setValue}
              error={this.getEmailError()}
            />
            <TextField
              id="phone"
              name="phone"
              label="Phone number - this will not be public"
              value={this.state.phone}
              handler={this.setValue}
              error={this.state.errors.phone}
            />
            <div className={css(styles.select_parent_container)}>
              <div className={css(styles.select_field_container)}>
                <Select
                  id="suburb"
                  name="suburb"
                  options={this.props.appdata.suburb.map(suburb => ({
                    value: suburb.id,
                    label: `${suburb.title}, ${suburb.district.title}`,
                  }))}
                  label="Suburb"
                  required
                  value={this.state.suburb}
                  type="location"
                  handler={this.setValue}
                  style={styles.select_style}
                  />
              </div>
            </div>
            <br />
            {
              !this.state.facebook_token ? (
                <TextField
                  id="password"
                  name="password"
                  type="password"
                  label="Password"
                  value={this.state.password}
                  handler={this.setValue}
                  error={this.state.errors.password}
                />
              ) : false
            }
            {
              !this.state.facebook_token ? (
                <TextField
                  id="confirmed_password"
                  name="confirmed_password"
                  type="password"
                  label="Re-Type Password"
                  value={this.state.confirmed_password}
                  handler={this.setValue}
                  error={this.state.errors.confirmed_password}
                />
              ) : false
            }
            <CheckboxField
              id="newsletter"
              name="newsletter"
              label="I want to sign up to email updates"
              value={this.state.newsletter}
              handler={this.setValue}
              fullWidth
            />
            <CheckboxField
              id="accepted_terms"
              name="accepted_terms"
              label={(
                <div>
                  I accept The Dog Share Collective{'\''}s&nbsp;
                  <a
                    href="/terms"
                    target="_blank"
                    rel="noopener noreferrer">
                    Terms of Service
                  </a>.
                </div>
              )}
              value={this.state.accepted_terms}
              handler={this.setValue}
              fullWidth
              error={this.state.errors.accepted_terms}
            />
            <HorizontalRule />
          </div>
          <div className={css(styles.actions)}>
            <Continue />
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  or_label: {
    display: 'block',
    margin: '15px 0 -20px',
    textAlign: 'center',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: '#a5a5a5',
    textTransform: 'uppercase',
    fontSize: 13,
    letterSpacing: 1.8,
  },
  facebook_btn: {
    display: 'block',
    width: '100%',
    maxWidth: 340,
    height: 50,
    margin: '0 auto',
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#1a488f',
    cursor: 'pointer',
    outline: 'none',
  },
  container: {
    padding: `86px 0 ${Theme.footer.height}px`,
    transition: 'transform 500ms',
    transform: 'translateX(100vw)',

    [Theme.mobile_query]: {
      padding: '50px 0',
    },
  },
  container_active: {
    transform: 'translateX(0)',
  },
  container_inactive: {
    display: 'none',
  },
  container_completed: {
    transform: 'translateX(-100vw)',
  },
  main: {
    width: 750,
    margin: '0 auto',

    [Theme.mobile_query]: {
      width: '100%',
      padding: '0 15px',
    },
  },
  heading: {
    marginBottom: 42,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,

    [Theme.mobile_query]: {
      fontSize: 28,
    },
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -5px',
  },
  select_container: {
    position: 'relative',
  },
  select_parent_container: {
    position: 'relative',
    padding: '0px 5px',
    marginBottom: '15px',
    width: '100%',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  select_field_container: {
    position: 'relative',
    zIndex: 10,
    width: '50%',
    paddingRight: '5px',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  select_style: {
    width: '100%',
    height: '48px',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  continue: {
    width: 340,
    height: 50,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: Theme.primary,
    cursor: 'pointer',
    outline: 'none',
  },
});

JoinDetails.propTypes = {
  user: PropTypes.object.isRequired,
  appdata: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(JoinDetails);



// WEBPACK FOOTER //
// ./src/views/JoinDetails/index.js